import helpCenterApiLink from '../variables/helpCenterApiLinks.json';

export const helpCenterApi = apiName => {
  return helpCenterApiLink[apiName];
};